/**
 * Sticky header behaviour (from the handoff):
 *  - .scrolled past 12px (border + shadow)
 *  - .hide when scrolling down past 260px; reveal on scroll up
 *  - .compact (mark-only logo) when revealed mid-page (>120px)
 *  - back-to-top button fades in past 500px
 */
export function initHeader() {
	const header = document.getElementById('site-header');
	const toTop = document.getElementById('to-top');
	if (!header) return;

	let last = window.scrollY;

	function onScroll() {
		const y = window.scrollY;
		header.classList.toggle('scrolled', y > 12);

		if (y <= 4) {
			header.classList.remove('hide', 'compact');
		} else if (y > last + 4 && y > 260) {
			header.classList.add('hide');
		} else if (y < last - 4) {
			header.classList.remove('hide');
			header.classList.toggle('compact', y > 120);
		}
		last = y;

		if (toTop) toTop.classList.toggle('show', y > 500);
	}

	window.addEventListener('scroll', onScroll, { passive: true });
	if (toTop) {
		toTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
	}
	onScroll();
}
